import ResidentAllergiesDietTemplate from "app/features/residents/templates/view/ResidentAllergiesDietTemplate";

export default function AllergiesDietScreen() {
  return <ResidentAllergiesDietTemplate />;
}
